module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-4-min.cbfcbe2e.jpg";